// Vendor PayPal emails whose payments are private — filtered out of the
// payments inbox display. (Display-only: these records are still stored/synced.)
const PRIVATE_PAYPAL_EMAILS = new Set<string>([
  "pauljacobcruz@ymail.com",
  "nikolyndee@gmail.com",
  "vinceramirez016@gmail.com",
  "daleturla.codecaveit@gmail.com",
  "bryan_talaban@yahoo.com",
  "clunzaran7@gmail.com",
  "bryanbautista1004@gmail.com",
  "reynalyndelosreyesculalic@gmail.com",
  "kimcruzzzzz8@gmail.com",
  "rawbeancee@gmail.com",
]);

export function isPrivatePaypalEmail(email: string | undefined | null): boolean {
  return Boolean(email) && PRIVATE_PAYPAL_EMAILS.has(email!.trim().toLowerCase());
}

// Mercury counterparty ids of the same private vendors. PayPal funds their
// payouts from Mercury, and Mercury names each debit after the recipient — so
// hide these too, in case a debit isn't tagged as PayPal funding.
const PRIVATE_MERCURY_COUNTERPARTY_IDS = new Set<string>([
  "f851e360-0088-11f1-bf06-5310afb77260", // Paul Jacob Cruz
  "7f2058aa-53e9-11f1-9bce-b31e61921cf2", // Kim Cruz
  "c3899554-0d19-11f1-b8a8-4303f9ac0776", // Marcial Bryan Talaban
  "d5d88256-0c51-11f1-ad10-d3797eaea557", // Vince Clyde Ramirez
  "cda9bc36-0c50-11f1-8a76-4773ff68dea0", // Charolyndee Ramirez
  "d79f769e-0c51-11f1-9fb9-43e411be5311", // John Dale Turla
  "d6f56c4e-0c51-11f1-8ae9-ab7f0dbcc939", // Carina Lunzaran
  "fbe2d43e-5ee9-11f1-9589-7fe0a5c868e1", // Robin Caleja
  "d3b450ae-0c51-11f1-83a0-07b230e5b318", // Reynalyn Culalic
]);

export function isPrivateMercuryCounterparty(
  counterpartyId: string | undefined | null,
): boolean {
  return (
    Boolean(counterpartyId) &&
    PRIVATE_MERCURY_COUNTERPARTY_IDS.has(counterpartyId!)
  );
}
